// @flow
import { createSelector } from "reselect";
import {
	getListReachedMaxSelection,
	getListMultipleIdsInRange,
	getListAvailableUntilMax,
} from "../../common/selectors";
import { selectBatchStartCounter } from "../../../root/selectors";

const getSelected = (state: Object) => state.imageSearch.selected;
const getImages = (state: Object) => state.imageSearch.images;
const getMaxData = (state: Object) => ({
	selected: getSelected(state),
	maxAllowed: state.widgetConfig.maxFiles,
	successfulCount: state.widgetData.successfulCount,
});


const selectImageSearchConfig: Object => Object = createSelector(
	(state: Object) => ({
		widgetConfig: state.widgetConfig,
		imageSearch: {
			searchTerm: state.imageSearch.searchTerm,
			images: getImages(state),
			selected: getSelected(state),
			queries: state.imageSearch.queries || {},
			searchRight: state.imageSearch.searchRight,
			searchRightIndex: state.imageSearch.searchRightIndex,
			showOptions: state.imageSearch.showOptions,
			searchSiteIndex: state.imageSearch.searchSiteIndex,
			searchSite: state.imageSearch.searchSite,
			firstSearch: state.imageSearch.firstSearch,
			searchDone: state.imageSearch.searchDone,
			showProgress: state.imageSearch.progressIndicator,
			searchError: state.imageSearch.searchError,
		},
	}),
	selectBatchStartCounter,
	({ widgetConfig, imageSearch }, batchStartCounter) => ({
		apiKey: widgetConfig.googleApiKey,
		isMultiple: widgetConfig.multiple,
		showRights: widgetConfig.searchByRights,
		sites: widgetConfig.searchBySites,
		batchStartCounter,
		...imageSearch,
	}),
);

const selectSearchTerm: Object => Object = createSelector(
	(state: Object) => state.imageSearch.searchTerm,
	(searchTerm) => ({ searchTerm }),
);

const selectIsIdSelected: Object => Function = createSelector(
	getSelected,
	(selected) => (id) => (selected.indexOf(id) > -1),
);

const selectReachedMaxSelection: Object => boolean = createSelector(
	getMaxData,
	(data) => getListReachedMaxSelection(data, data.maxAllowed, data.successfulCount),
);

const selectMultipleIdsInRange: Object => Function = createSelector(
	(state: Object) => ({ selected: getSelected(state), items: getImages(state) }),
	(data) => (id: string) => getListMultipleIdsInRange(data, id),
);

const selectAvailableUntilMax: Object => number = createSelector(
	getMaxData,
	(data) => getListAvailableUntilMax(data, data.maxAllowed, data.successfulCount),
);

export {
	selectImageSearchConfig,
	selectSearchTerm,
	selectIsIdSelected,
	selectReachedMaxSelection,
	selectMultipleIdsInRange,
	selectAvailableUntilMax,
};
